import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/NavigationBar.css";

const NavBar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    // { to: "/ourwork", label: "Our Works" },
    { to: "/blogs", label: "Blogs" },
    { to: "/resources", label: "Resources" },
  ];

  useEffect(() => {
    const resize = () => window.innerWidth > 1024 && setMenuOpen(false);
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }) =>
    "nav-link text-secondary" + (isActive ? " active" : "");

  const navLinks = links.map(({ to, label }) => (
    <NavLink
      key={to}
      to={to}
      className={linkClass}
      end={to === "/"}
      onClick={() => setMenuOpen(false)}
    >
      {label}
    </NavLink>
  ));

  return (
    <nav>
      <div
        className="logo"
        onClick={() => handleNavigate("/")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && handleNavigate("/")}
        aria-label="Navigate to home"
      >
        <img className="logo-img" src="/assets/sepllogo.png" alt="SEPL Logo" />
      </div>

      <div className="nav-links text-white">{navLinks}</div>

      <div className="right-buttons">
        <button
          className="contactus-btn btn-secondary"
          onClick={() => handleNavigate("/contactus")}
        >
          Contact Us
        </button>
      </div>

      <div className="hamburger-wrapper">
        <div
          className={`hamburger ${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          role="button"
          tabIndex={0}
          aria-label="Toggle menu"
          onKeyDown={(e) => e.key === "Enter" && setMenuOpen(!menuOpen)}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div
        className={`mobile-menu bg-primary text-secondary${menuOpen ? " open" : ""}`}
      >
        {navLinks}

        <button
          className=".contactus-btn btn-secondary w-50"
          onClick={() => handleNavigate("/contactus")}
        >
          Contact Us
        </button>
      </div>
    </nav>
  );
};

export default NavBar;
